import { Theme } from '@mui/material'
import { SystemStyleObject } from '@mui/system'

export const mobileFieldGapSx: SystemStyleObject<Theme> = {
  mb: { xs: 1, sm: 0 },
}
